import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'react-bootstrap/Badge';
import { Table } from 'reactstrap';
import TagsViewer from '../../atoms/TagsViewer/TagsViewer';
import shortDateFormat from '../../../helpers/dates';
import './InstanceMetadata.scss';

const InstanceMetadata = ({
  title,
  instance,
}) => (
  <div className="row mt-3">
    <Table striped hover responsive>
      <thead>
        <tr className="text-center">
          <th colSpan={2}>{title}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Title</td>
          <td>{`${instance.name} [${instance.code}]`}</td>
        </tr>
        {instance.scholar && (
          <tr>
            <td>Scholar</td>
            <td>{instance.scholar}</td>
          </tr>
        )}
        {instance.invention && (
          <tr>
            <td>Invention</td>
            <td>{instance.invention}</td>
          </tr>
        )}
        {instance.creator_name && (
          <tr>
            <td>Creator Name</td>
            <td>{instance.creator_name}</td>
          </tr>
        )}
        {instance.start_date && (
          <tr>
            <td>Start Date</td>
            <td>{instance.start_date}</td>
          </tr>
        )}
        {instance.end_date && (
          <tr>
            <td>End Date</td>
            <td>{instance.end_date}</td>
          </tr>
        )}
        <tr>
          <td>Location</td>
          <td>
            {`${instance.city.name}, ${instance.city.country.name} [${instance.city.code}]`}
          </td>
        </tr>
        <tr>
          <td>Dynasty</td>
          <td>
            {`${instance.dynasty.name}, [${instance.dynasty.code}]`}
          </td>
        </tr>
        <tr>
          <td>Tags</td>
          <td>
            <TagsViewer tags={instance.tags} />
          </td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <Badge bg={instance.in_review === 1 ? 'warning' : 'success'} pill>
              {instance.in_review === 1 ? 'In Review' : 'Published'}
            </Badge>
          </td>
        </tr>
        <tr>
          <td>Date Created</td>
          <td>
            {shortDateFormat(instance.created_at)}
          </td>
        </tr>
        <tr>
          <td>Last Update</td>
          <td>
            {shortDateFormat(instance.updated_at)}
          </td>
        </tr>
      </tbody>
    </Table>
  </div>
);

InstanceMetadata.propTypes = {
  title: PropTypes.string.isRequired,
  instance: PropTypes.object.isRequired,
};

InstanceMetadata.defaultProps = {

};

export default InstanceMetadata;
